// extracted by mini-css-extract-plugin
module.exports = {"root":"detail-value_root__DACX3"};